module.exports = __webpack_public_path__ + "img/powerAmplifier500w.14d7120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/powerAmplifier500w.png
// module id = RbhY
// module chunks = 0